// AboutPage.js
import React from "react";
import Navbar from "../components/ui/Navbar";
import Footer from "../components/ui/Footer";
import { LucideLinkedin } from "lucide-react";

const AboutPage = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    {/* Navbar */}
    <Navbar />

    {/* Main Content */}
    <div className="flex-grow container mx-auto py-20 px-4">
      <h1 className="text-5xl font-bold mb-8 text-center text-blue-600">About Query Minds</h1>
      <p className="text-lg mb-6 text-gray-700 text-center">
        At Query Minds, we are a dedicated team of IT professionals passionate about delivering innovative technology solutions. Our mission is to empower businesses with cutting-edge IT services that drive efficiency, foster growth, and enhance overall success.
      </p>

      <h2 className="text-3xl font-bold mb-6 text-blue-600 text-center">Meet the Founders</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
        {/* Milos Vukovic */}
        <div className="p-6 bg-white shadow-md rounded-lg">
          <div className="flex justify-between items-center">
            <h3 className="text-2xl font-semibold mb-4 text-blue-600">Milos Vukovic</h3>
            <a
              href="https://www.linkedin.com/in/milosvukovic1996/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Milos Vukovic LinkedIn"
              className="text-blue-600 hover:text-blue-800"
            >
              <LucideLinkedin className="h-6 w-6" />
            </a>
          </div>
          <p className="text-gray-700 mb-4">
            Milos is a highly skilled IT professional with a master's degree in Cybersecurity from Georgia Tech. He brings years of experience in network security, vulnerability management, and software development. His analytical and results-driven approach ensures businesses remain secure and efficient in an ever-evolving tech landscape.
          </p>
          <ul className="list-disc list-inside text-gray-700">
            <li>Network Security & Vulnerability Management</li>
            <li>Cybersecurity Strategies</li>
            <li>IT Systems Administration and Optimization</li>
            <li>AI and Machine Learning Integration</li>
          </ul>
        </div>

        {/* Milos Bogdanovic */}
        <div className="p-6 bg-white shadow-md rounded-lg">
          <div className="flex justify-between items-center">
            <h3 className="text-2xl font-semibold mb-4 text-blue-600">Milos Bogdanovic</h3>
            <a
              href="https://www.linkedin.com/in/milos-bogdanovic-312364212/?trk=people-guest_people_search-card&originalSubdomain=ca"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Milos Bogdanovic LinkedIn"
              className="text-blue-600 hover:text-blue-800"
            >
              <LucideLinkedin className="h-6 w-6" />
            </a>
          </div>
          <p className="text-gray-700 mb-4">
            Milos is an experienced IT specialist with expertise in systems architecture, full-stack development, and project management. His ability to blend technical knowledge with business acumen ensures seamless delivery of scalable and efficient IT solutions.
          </p>
          <ul className="list-disc list-inside text-gray-700">
            <li>Full-Stack Development (React, Node.js, Python)</li>
            <li>Systems Design & Architecture</li>
            <li>Cloud Solutions (Azure, AWS)</li>
            <li>Data Analytics and Workflow Automation</li>
          </ul>
        </div>
      </div>

      <h2 className="text-3xl font-bold mb-6 text-blue-600 text-center">Our Mission</h2>
      <p className="text-lg mb-6 text-gray-700 text-center">
        At Query Minds, we are committed to delivering customized IT solutions that are tailored to meet the unique needs of each client. By combining advanced technology with deep industry expertise, we help businesses overcome challenges and achieve their goals.
      </p>

      <h2 className="text-3xl font-bold mb-6 text-blue-600 text-center">Why Choose Query Minds?</h2>
      <ul className="list-disc list-inside mx-auto max-w-2xl text-gray-700">
        <li className="mb-2">
          <span className="font-bold">Client-Centric Approach:</span> We prioritize understanding your needs to deliver solutions that align with your vision.
        </li>
        <li className="mb-2">
          <span className="font-bold">Expert Team:</span> With decades of combined experience, our team is equipped to tackle diverse IT challenges.
        </li>
        <li className="mb-2">
          <span className="font-bold">Cutting-Edge Technology:</span> We stay ahead of industry trends to provide innovative solutions that drive results.
        </li>
      </ul>
    </div>

    {/* Footer */}
    <Footer />
  </div>
);

export default AboutPage;
